import { useState } from "react";
import { Button, Form } from "react-bootstrap";
import PopUpModal from "../Modal";
import * as postapi from "../../api/postapi";
import useApi from "../../Hooks/useApi";
import { toast } from "react-toastify";

const MarkSpamModal = ({ show, data, onHide, toggle, mode = "mark" }) => {
  const [isClicked, setIsClicked] = useState(false);
  const [error, setError] = useState("");
  const [reason, setReason] = useState("");
  const markAsSpamCall = useApi(postapi.markAsSpam, { hasCatchError: true });
  const unmarkSpamCall = useApi(postapi.unmarkSpam, { hasCatchError: true });
  const close = () => {
    setIsClicked(false);
    onHide();
    setError("");
    setReason("");
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setIsClicked(true);
      const response = mode === "unmark"
        ? await unmarkSpamCall.request(data.id)
        : await markAsSpamCall.request(data.id, reason || undefined);
      if (response.status === 200) {
        toast.success(`${response?.data?.message}`, {
          position: "bottom-right",
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        close();
        toggle();
      }
    } catch (error) {
      setError(error.response.data.error.message);
      setIsClicked(false);
    }
  };
  const isUnmark = mode === "unmark";
  return (
    <PopUpModal
      title={isUnmark ? "Remove Spam Status" : "Mark as Spam"}
      show={show}
      onHide={close}
      closeButton={false}
    >
      <>
        {error && <div className="text-danger text-center my-1 rounded-1 w-100">*{error}</div>}

        <div>
          <span className="d-flex justify-content-center pb-3">
            {isUnmark
              ? "Are you sure you want to remove the spam status from this order?"
              : "Are you sure you want to mark this order as spam?"}
          </span>
        </div>

        {!isUnmark && (
          <Form.Group className="mb-3">
            <Form.Label className="fw-bold" style={{ fontSize: "14px" }}>
              Reason (optional)
            </Form.Label>
            <Form.Control
              as="textarea"
              rows={2}
              placeholder="Enter reason for marking as spam..."
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              style={{ fontSize: "14px" }}
            />
          </Form.Group>
        )}

        <div className="d-flex gap-3">
          <span
            className="w-100 d-flex justify-content-center align-items-center text-secondary p-2 border-2 border-secondary"
            style={{
              cursor: "pointer",
              border: "2px solid rgba(151, 156, 162, 1)",
              borderRadius: "6px",
            }}
            onClick={() => close()}
          >
            Cancel
          </span>
          <Button
            className="w-100"
            variant={isUnmark ? "warning" : "primary"}
            onClick={handleSubmit}
            disabled={isClicked}
          >
            {isUnmark ? "Remove Spam" : "Spam"}
          </Button>
        </div>
      </>
    </PopUpModal>
  );
};

export default MarkSpamModal;
